import { Button } from "@/components/ui/button";
import { Bell, BellOff, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface NotificationPromptProps {
  onEnable: () => void;
  onDismiss: () => void;
  isUpsell?: boolean;
  className?: string;
}

export function NotificationPrompt({ 
  onEnable, 
  onDismiss, 
  isUpsell = false,
  className 
}: NotificationPromptProps) {
  return (
    <div className={cn(
      "p-4 rounded-lg border border-primary/30 bg-primary/5 relative",
      className
    )}>
      <button 
        onClick={onDismiss}
        className="absolute top-2 right-2 p-1 text-muted-foreground hover:text-foreground transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
      
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full evolve-gradient flex items-center justify-center shrink-0">
          {isUpsell ? <BellOff className="w-5 h-5" /> : <Bell className="w-5 h-5" />}
        </div>
        
        <div className="flex-1 pr-4">
          {isUpsell ? (
            <>
              <p className="font-medium text-sm">
                Notifications Off = Devolving
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Evolvers with notifications on are <span className="text-primary font-bold">4.7× more likely</span> to hit Immortal. Turn them on now.
              </p>
            </>
          ) : (
            <>
              <p className="font-medium text-sm">
                🔔 Enable Notifications
              </p>
              <p className="text-xs text-muted-foreground mt-1">
                Get daily nudges for gym time, weigh-ins, and motivation. Mortals don't evolve.
              </p>
            </>
          )}
          
          <Button 
            onClick={onEnable}
            size="sm"
            variant="evolve"
            className="mt-3 w-full"
          >
            <Bell className="w-4 h-4 mr-2" />
            Enable Notifications
          </Button>
        </div>
      </div>
    </div>
  );
}
